module.exports = __webpack_public_path__ + "media/images/logo-global-white-130cb9ade3fab7a24d3115fe57b5b764.png";